import React from "react";
import { useNavigate } from "react-router-dom";
import { useMessaging } from "../../context/MessagingContext";
import { useUserRole } from "../../context/UserRoleContext";

const MessageBell = () => {
  const { unreadCount } = useMessaging();
  const { userData } = useUserRole();
  const navigate = useNavigate();

  const handleClick = () => {
    const basePath =
      userData?.role === "artist"
        ? "/artist"
        : userData?.role === "bar_owner"
        ? "/bar-owner"
        : "/bar-admin";

    navigate(`${basePath}/messages`);
  };

  return (
    <div className="message-bell-container">
      <button
        className="message-bell-button"
        onClick={handleClick}
        aria-label="Messages"
      >
        <span className="message-icon">💬</span>
        {unreadCount > 0 && (
          <span className="message-badge">
            {unreadCount > 99 ? "99+" : unreadCount}
          </span>
        )}
      </button>
    </div>
  );
};

export default MessageBell;
